// In production, nginx proxies /api/ to the shared Node server on
// localhost:3002 (same server the warehouse app uses), so reports go
// same-origin over HTTPS. In local dev (CRA on :3000) there is no proxy, so
// hit the Node server directly.
const ERROR_ENDPOINT =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3002/api/error-report'
    : '/api/error-report';

// Read the logged-in user straight from localStorage (set by LoginForm under
// LOCAL_STORAGE.USERNAME / USER_EMAIL). No app imports here: this module runs
// inside global error handlers, so it must never be part of an import cycle
// or throw.
function readStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key)) || '';
  } catch (_) {
    return '';
  }
}

export function reportError(error, extra = {}) {
  try {
    const payload = {
      source: 'Vendor PWA',
      message: error?.message || String(error),
      stack: error?.stack,
      url: window.location.href,
      user: readStorage('username') || 'unknown',
      email: readStorage('user_email'),
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      ...extra,
    };

    navigator.sendBeacon(
      ERROR_ENDPOINT,
      new Blob([JSON.stringify(payload)], { type: 'application/json' })
    );
  } catch (_) {
    // Don't let error reporting cause more errors
  }
}

// Catch unhandled errors globally
window.addEventListener('error', (event) => {
  reportError(event.error || event.message, { type: 'unhandled' });
});

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  reportError(event.reason || 'Unhandled promise rejection', { type: 'unhandledrejection' });
});
